import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MRT_RowSelectionState } from 'material-react-table';
import clsx from 'clsx';
import { CheckPicker, DateRangePicker } from 'rsuite';
import { isAfter } from 'date-fns';
import './DisputesQueueDetailsHeader.scss';
import { SearchInputSmall } from '../../../common/SearchInputSmall';
import { useDisputesContext } from '../../../../store/disputes/disputes-context';
import { NumberFilterComponent } from '../../../filter/TextFilterComponent';
import { getFormattedDate, makeSearchParams } from '../../../../utils/utilities';
import { FilterComponent } from '../../../FilterComponent';
import { BUTTON_TYPE, ButtonComponent } from '../../../ButtonComponent';
import { RenderExtraFooter } from '../../../filter/RenderExtraFooter';
import { MatchDisputeModal } from '../../MatchDisputeModal';
import { IModalWindow, ModalWindow } from '../../../modal/ModalWindow';
import { isEqual } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { fetchKountStatusCodes } from '../../../../store/disputes/actions/disputes';
import { AlertProviderModal } from '../../AlertProviderModal';
import { ITransactionsData } from '../../../../store/payments/payments-interfaces-helper';
import { ITransactionsFilters } from '../../../transactions/TransactionsPageFilter';
import { ROUTES } from '../../../../routing/routesEnums';

interface Props {
	checkedItem: ITransactionsData | null;
	setCheckedItem?: (value: ITransactionsData) => void;
	rowSelection?: MRT_RowSelectionState;

	from: Date | string;
	to: Date | string;
	// provider: string[];
	type: string[];
	status: string[];
	arn: string;
	amount: string;
	bin: string;
	last4: string;
	orderId: string;
	transactionId: string;
	externalReferenceId: string;
	authCode: string;
	query: string;
	pageSize: string;
	pageNumber: string;

	setFrom: (value: Date | string) => void;
	setTo: (value: Date | string) => void;
	// setProvider: (value: string[]) => void;
	setType: (value: string[]) => void;
	setStatus: (value: string[]) => void;
	setArn: (value: string) => void;
	setAmount: (value: string) => void;
	setBin: (value: string) => void;
	setLast4: (value: string) => void;
	setOrderId: (value: string) => void;
	setTransactionId: (value: string) => void;
	setExternalReferenceId: (value: string) => void;
	setAuthCode: (value: string) => void;
	setQuery: (value: string) => void;

	appliedFiltersState: ITransactionsFilters;
	setAppliedFiltersState: (value: ITransactionsFilters) => void;

	transactionsData: ITransactionsData[];
	isTranslationDataLoading: boolean;
}

export const DisputesQueueDetailsHeader: FC<Props> = (props) => {
	const {
		checkedItem, setCheckedItem, rowSelection,
		from, to,
		// provider, setProvider,
		type, status, arn,
		amount, bin, last4, orderId, transactionId,
		externalReferenceId, authCode, query, pageNumber, pageSize,
		setFrom, setTo, setType, setStatus, setArn, setAmount, setBin, setLast4, setOrderId,
		setTransactionId, setExternalReferenceId, setAuthCode, setQuery,
		appliedFiltersState, setAppliedFiltersState, transactionsData, isTranslationDataLoading
	} = props;

	// const picker = useRef(null);
	const typesPicker = useRef(null);
	const statusesPicker = useRef(null);
	const arnRef = useRef(null);
	const amountRef = useRef(null);
	const binRef = useRef(null);
	const last4Ref = useRef(null);
	const orderIdRef = useRef(null);
	const transactionIdRef = useRef(null);
	const externalIdRef = useRef(null);
	const authIdRef = useRef(null);

	const { pathname, state } = useLocation();
	const navigate = useNavigate();

	const {
		disputesContextState: {
			disputeDetails,
			disputeDetailsLists,
			kountStatusCodes
		},
		dispatch: disputesDispatch
	} = useDisputesContext();

	const initialFilterState: ITransactionsFilters = {
		query,
		from,
		to,
		// provider,
		type,
		status,
		arn,
		amount,
		bin,
		last4,
		orderId,
		transactionId,
		externalReferenceId,
		authCode,
		pageNumber,
		pageSize
	};
	const [selectedFiltersState, setSelectedFiltersState] = useState<ITransactionsFilters>(initialFilterState);

	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});

	const [isMatchModalOpen, setIsMatchModalOpen] = useState<boolean>(false);
	const [alertModalProvider, setAlertModalProvider] = useState<string | null>(null);

	const returnUrl = state?.disputeQueueItem?.disputeQueueId ?
		`${ROUTES.DISPUTES}${ROUTES.DISPUTES_QUEUE}/${state?.disputeQueueItem?.disputeQueueId}${state?.disputeQueueItem?.search || ''}`
		: `${ROUTES.DISPUTES}${ROUTES.DISPUTES_ARCHIVED}${state?.search || ''}`;

	useEffect(() => {
		if (Object.values(kountStatusCodes || {})?.length == 0) {
			void fetchKountStatusCodes(disputesDispatch);
		}
	}, []);

	useEffect(() => {
		setSelectedFiltersState(initialFilterState);
	}, [
		// provider,
    query, from, type, status, arn, amount, bin,
    last4, orderId, transactionId, externalReferenceId, authCode,
  ]);

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	const matchModalClose = (): void => {
		closeModal();
		navigate(returnUrl, { state: { disputeQueuesSearch: state?.disputeQueuesSearch }});
	};

	const closeMatchModal = (): void => setIsMatchModalOpen(false);
	const closeAlertModal = (): void => setAlertModalProvider(null);

	const selectedItem = Object.keys(rowSelection || {});

	const onMatch = (): void => {
		setIsMatchModalOpen(true);
		const item = transactionsData?.find(el => el?.id === selectedItem[0]);

		if (item) {
			setCheckedItem(item);
		}
	};

	const onNotMatch = (): void => {
		if (disputeDetails?.disputeManagementSystem === 'Chargeblast') {
			setAlertModalProvider('Chargeblast');
		} else {
			setAlertModalProvider(disputeDetails?.providerName);
		}

		const item = transactionsData?.find(el => el?.id === selectedItem[0]);

		if (item) {
			setCheckedItem(item);
		}
	};
	const matchSuccess = (): void => {
		closeMatchModal();
		closeAlertModal();
		setModalState({
			isOpen: true,
			modalTitle: 'Match dispute success',
			modalText: 'Matched successfully',
			confirmButtonText: 'Ok',
			minHeight: 100,
			backdrop: 'static',
			onConfirm: matchModalClose,
			onClose: matchModalClose,
		});
	};
	const matchAlertSuccess = (): void => {
		closeMatchModal();
		closeAlertModal();
		setModalState({
			isOpen: true,
			modalTitle: `Alert ${alertModalProvider}`,
			modalText: 'Alert is successed',
			confirmButtonText: 'Ok',
			minHeight: 100,
			backdrop: 'static',
			onConfirm: matchModalClose,
			onClose: matchModalClose,
		});
	};

	const matchAlertError = (error: any):void => {
		console.log('error', error);
		const errorText = error?.errors?.General?.[0] || error?.errors || error || 'Alert failed';
		closeAlertModal();
		setModalState({
			isOpen: true,
			modalTitle: `Alert ${alertModalProvider} error`,
			modalText: errorText,
			confirmButtonText: 'Ok',
			minHeight: 100,
			onConfirm: closeModal,
			onClose: closeModal
		});
	};

	const matchError = (error: any):void => {
		console.log('error', error);
		const errorText = error?.errors?.General?.[0] || error?.errors || 'Matching failed';
		closeMatchModal();
		setModalState({
			isOpen: true,
			modalTitle: 'Match dispute error',
			modalText: errorText,
			confirmButtonText: 'Ok',
			minHeight: 100,
			onConfirm: closeModal,
			onClose: closeModal
		});
	};

	// const allProviders = disputeDetailsLists?.providers?.map(item => item.value);
	const allTypes = disputeDetailsLists?.types?.map(item => item.value);
	const allStatuses = disputeDetailsLists?.statuses?.map(item => item.value);

	// const handleCheckAll = (value, checked): void => {
	// 	const selectedValues = checked ? allProviders : [];
	// 	setProvider(selectedValues);
	// };

	const handleCheckAllTypes = (value, checked): void => {
		const selectedValues = checked ? allTypes : [];
		setType(selectedValues);
	};

	const handleCheckAllStatuses = (value, checked): void => {
		const selectedValues = checked ? allStatuses : [];
		setStatus(selectedValues);
	};

	// const handleSaveProviders = (): void => picker.current?.close();

	const handleSaveTypes = (): void => typesPicker.current?.close();

	const handleSaveStatuses = (): void => statusesPicker.current?.close();

	const isSelectedFilters = from
		|| query || arn || amount || bin || last4
		// || provider.length
		|| status.length || type.length
		|| orderId || transactionId || authCode || externalReferenceId;

	const handleCleanFilter = (): void => {
		if (isSelectedFilters) {
			setQuery('');
			// setProvider([]);
			setStatus([]);
			setType([]);
			setAmount('');
			setArn('');
			setBin('');
			setLast4('');
			setOrderId('');
			setTransactionId('');
			setExternalReferenceId('');
			setAuthCode('');
			setFrom(null);
			setTo(null);
		}
	};

	const handleSearch = async (): Promise<void> => {
		setAppliedFiltersState(initialFilterState);
		navigate(`${pathname}?${makeSearchParams(initialFilterState)}`, { state: { ...state }});
	};

	return (
		<div className="card bg-transparent">

			<div className="d-sm-flex align-items-center justify-content-between flex-wrap application-selector mb-5">

				<div className="d-sm-flex align-items-center">
					<SearchInputSmall
						placeholder="Search"
						additionalClass=""
						searchValue={query}
						setSearchValue={setQuery}
					/>

					<ButtonComponent
						additionalClass="btn-sm w-100px d-none d-sm-block ms-10"
						onButtonClick={handleSearch}
						isDisabled={isTranslationDataLoading || isEqual(initialFilterState, appliedFiltersState)}
						loading={isTranslationDataLoading}
					>
						<>
							{
								isEqual(selectedFiltersState, appliedFiltersState)
									? 'Search'
									: (
										<div className="d-flex align-items-center justify-content-center">
											<FontAwesomeIcon icon={faTriangleExclamation} />
											<span className="ms-2 fw-bolder">Refresh</span>
										</div>
									)
							}
						</>
					</ButtonComponent>
				</div>
				<div className="d-flex align-items-right d-none d-sm-block">
					{/*{getSelectPicker()}*/}
					<ButtonComponent
						buttonType={BUTTON_TYPE.WHITE}
						buttonName="Match dispute"
						isDisabled={!selectedItem.length}
						onButtonClick={onMatch}
					/>

					{
						disputeDetails?.stage !== 'CHARGEBACK' &&
						disputeDetails?.kountEventType !== 'FRAUD_NOTICE' &&
						disputeDetails?.kountEventType !== 'FRAUD_NOTICE' &&
						disputeDetails?.eventType !== 'DISPUTE_NOTICE' &&
						disputeDetails?.eventType !== 'DISPUTE_NOTICE' &&
						!!disputeDetails && ['kount', 'myrcvr', 'chargeblast', 'ethoca'].includes(disputeDetails?.providerName?.toLowerCase()) && (
							<ButtonComponent
								buttonType={BUTTON_TYPE.WHITE}
								buttonName={`Alert ${disputeDetails?.providerName}`}
								onButtonClick={onNotMatch}
								additionalClass="ms-2"
								isDisabled={!selectedItem.length}
							/>
						)
					}
				</div>

			</div>

			<div className="d-sm-none d-flex align-items-center mb-5">
				<ButtonComponent
					additionalClass="btn-sm w-100"
					onButtonClick={handleSearch}
					isDisabled={isTranslationDataLoading}
					loading={isTranslationDataLoading}
				>
					<>
						{
							isEqual(selectedFiltersState, appliedFiltersState)
								? 'Search'
								: (
									<div className="d-flex align-items-center justify-content-center">
										<FontAwesomeIcon icon={faTriangleExclamation} />
										<span className="ms-2 fw-bolder">Refresh</span>
									</div>
								)
						}
					</>
				</ButtonComponent>
			</div>
			<div className="d-flex align-items-center fc-filter-line">
				<FilterComponent value={from} label="Created date" labelPlacement="integrated">
					<div className={clsx('fc-datepicker fc-range-datepicker-without-time', from && 'fc-added-icon')}>
						<DateRangePicker
							placeholder="Created date"
							placement="auto"
							onChange={(value): void => {
								const dateFrom = value?.[0] ? getFormattedDate(value[0], 'yyyy-MM-dd HH:mm:ss') : null;
								const dateTo = value?.[1] ? getFormattedDate(value[1], 'yyyy-MM-dd HH:mm:ss') : null;
								setFrom(dateFrom);
								setTo(dateTo);
							}}
							onClean={(): void => {
								setFrom(null);
								setTo(null);
							}}
							shouldDisableDate={(date): boolean => isAfter(date, new Date())}
							value={!from || !to ? null : [new Date(from), new Date(to)]}
							showOneCalendar
							disabled={isTranslationDataLoading}
						/>
					</div>
				</FilterComponent>
				{/*<FilterComponent value={provider.length} label="Providers" labelPlacement="integrated">*/}
				{/*	<CheckPicker*/}
				{/*		data={disputeDetailsLists?.providers || []}*/}
				{/*		ref={picker}*/}
				{/*		searchable={false}*/}
				{/*		value={provider}*/}
				{/*		onChange={(value): void => setProvider(value)}*/}
				{/*		onClean={(): void => setProvider([])}*/}
				{/*		placeholder='Providers'*/}
				{/*		className={clsx('fc-selector picker-selector', !provider.length && 'fc-added-icon')}*/}
				{/*		appearance="subtle"*/}
				{/*		placement="bottomEnd"*/}
				{/*		disabled={isTranslationDataLoading}*/}
				{/*		renderExtraFooter={(): ReactNode => (*/}
				{/*			<RenderExtraFooter*/}
				{/*				statusFilter={provider}*/}
				{/*				allValue={allProviders}*/}
				{/*				handleCheckAll={handleCheckAll}*/}
				{/*				handleSave={handleSaveProviders}*/}
				{/*			/>*/}
				{/*		)}*/}
				{/*	/>*/}
				{/*</FilterComponent>*/}
				<FilterComponent value={type.length} label="Types" labelPlacement="integrated">
					<CheckPicker
						data={disputeDetailsLists?.types || []}
						ref={typesPicker}
						searchable={false}
						value={type}
						onChange={(value): void => setType(value)}
						onClean={(): void => setType([])}
						placeholder='Types'
						className={clsx('fc-selector picker-selector', !type.length && 'fc-added-icon')}
						appearance="subtle"
						placement="bottomEnd"
						disabled={isTranslationDataLoading}
						renderExtraFooter={(): ReactNode => (
							<RenderExtraFooter
								statusFilter={type}
								allValue={allTypes}
								handleCheckAll={handleCheckAllTypes}
								handleSave={handleSaveTypes}
							/>
						)}
					/>
				</FilterComponent>
				<FilterComponent value={status?.length} label="Statuses" labelPlacement="integrated">
					<CheckPicker
						data={disputeDetailsLists?.statuses || []}
						ref={statusesPicker}
						searchable={false}
						value={status}
						onChange={(value): void => setStatus(value)}
						onClean={(): void => setStatus([])}
						placeholder='Statuses'
						className={clsx('fc-selector picker-selector', !status?.length && 'fc-added-icon')}
						appearance="subtle"
						placement="bottomEnd"
						disabled={isTranslationDataLoading}
						renderExtraFooter={(): ReactNode => (
							<RenderExtraFooter
								statusFilter={status}
								allValue={allStatuses}
								handleCheckAll={handleCheckAllStatuses}
								handleSave={handleSaveStatuses}
							/>
						)}
					/>
				</FilterComponent>
				<FilterComponent value={arn} isLoading={isTranslationDataLoading} label="Arn" labelPlacement="integrated">
					<NumberFilterComponent
						reference={arnRef}
						fieldLabel='Arn'
						close={(): void => arnRef.current.close()}
						open={(): void => arnRef.current.open()}
						value={arn}
						setValue={setArn}
						type="number"
						isLoading={isTranslationDataLoading}
					/>
				</FilterComponent>
				<FilterComponent value={amount} isLoading={isTranslationDataLoading} label="Amount" labelPlacement="integrated">
					<NumberFilterComponent
						reference={amountRef}
						fieldLabel='Amount'
						close={(): void => amountRef.current.close()}
						open={(): void => amountRef.current.open()}
						value={amount}
						setValue={setAmount}
						type="number"
						isLoading={isTranslationDataLoading}
					/>
				</FilterComponent>
				<FilterComponent value={bin} isLoading={isTranslationDataLoading} label="Bin" labelPlacement="integrated">
					<NumberFilterComponent
						reference={binRef}
						fieldLabel='Bin'
						close={(): void => binRef.current.close()}
						open={(): void => binRef.current.open()}
						value={bin}
						setValue={setBin}
						type="number"
						isLoading={isTranslationDataLoading}
						isBin
					/>
				</FilterComponent>
				<FilterComponent value={last4} isLoading={isTranslationDataLoading} label="Last4" labelPlacement="integrated">
					<NumberFilterComponent
						reference={last4Ref}
						fieldLabel='Last4'
						close={(): void => last4Ref.current.close()}
						open={(): void => last4Ref.current.open()}
						value={last4}
						setValue={setLast4}
						type="number"
						isLoading={isTranslationDataLoading}
						isLast4
					/>
				</FilterComponent>
				<FilterComponent value={orderId} isLoading={isTranslationDataLoading} label="Order id" labelPlacement="integrated">
					<NumberFilterComponent
						reference={orderIdRef}
						fieldLabel='Order id'
						close={(): void => orderIdRef.current.close()}
						open={(): void => orderIdRef.current.open()}
						value={orderId}
						setValue={setOrderId}
						type="text"
						isLoading={isTranslationDataLoading}
						isGuid
					/>
				</FilterComponent>
				<FilterComponent value={transactionId} isLoading={isTranslationDataLoading} label="Transaction id" labelPlacement="integrated">
					<NumberFilterComponent
						reference={transactionIdRef}
						fieldLabel='Transaction id'
						close={(): void => transactionIdRef.current.close()}
						open={(): void => transactionIdRef.current.open()}
						value={transactionId}
						setValue={setTransactionId}
						type="text"
						isLoading={isTranslationDataLoading}
						isGuid
					/>
				</FilterComponent>
				<FilterComponent value={externalReferenceId} isLoading={isTranslationDataLoading} label="External reference id" labelPlacement="integrated">
					<NumberFilterComponent
						reference={externalIdRef}
						fieldLabel='External reference id'
						close={(): void => externalIdRef.current.close()}
						open={(): void => externalIdRef.current.open()}
						value={externalReferenceId}
						setValue={setExternalReferenceId}
						type="text"
						isLoading={isTranslationDataLoading}
					/>
				</FilterComponent>
				<FilterComponent value={authCode} isLoading={isTranslationDataLoading} label="Authorization id" labelPlacement="integrated">
					<NumberFilterComponent
						reference={authIdRef}
						fieldLabel='Authorization id'
						close={(): void => authIdRef.current.close()}
						open={(): void => authIdRef.current.open()}
						value={authCode}
						setValue={setAuthCode}
						type="text"
						isLoading={isTranslationDataLoading}
					/>
				</FilterComponent>

				<div
					className={clsx(
						'text-danger text-decoration-underline',
						isSelectedFilters && !isTranslationDataLoading ? 'cursor-pointer' : 'cursor-not-allowed')
					}
					onClick={(): void => !isTranslationDataLoading && handleCleanFilter()}
				>
					Clear filters
				</div>
			</div>

			<div className="d-sm-none mb-5">
				<ButtonComponent
					buttonType={BUTTON_TYPE.WHITE}
					buttonName="Match dispute"
					isDisabled={!selectedItem.length}
					onButtonClick={onMatch}
					additionalClass="d-block w-100 mb-5"
				/>

				{
					!!disputeDetails && ['kount', 'myrcvr', 'chargeblast', 'ethoca'].includes(disputeDetails?.providerName?.toLowerCase()) && (
						<ButtonComponent
							buttonType={BUTTON_TYPE.WHITE}
							buttonName={`Alert ${disputeDetails?.providerName}`}
							onButtonClick={onNotMatch}
							additionalClass="d-block w-100"
						/>
					)
				}
			</div>
			<ModalWindow
				{...modalState}
			/>

			<ModalWindow
				isOpen={isMatchModalOpen}
				onClose={closeMatchModal}
				modalTitle="Match dispute"
				minHeight={180}
				backdrop="static"
				contentClassName="d-block"
				content={
					<MatchDisputeModal
						checkedItem={checkedItem}
						closeModal={closeMatchModal}
						matchSuccess={matchSuccess}
						matchError={matchError}
					/>
				}
			/>

			<ModalWindow
				isOpen={alertModalProvider !== null}
				onClose={closeAlertModal}
				modalTitle={`Alert ${alertModalProvider}`}
				minHeight={200}
				backdrop="static"
				contentClassName="d-block"
				content={
					<AlertProviderModal
						checkedItem={checkedItem}
						closeModal={closeAlertModal}
						matchSuccess={matchAlertSuccess}
						matchError={matchAlertError}
						alertModalProvider={alertModalProvider}
					/>
				}
			/>


		</div>
	);
};
